import moment from 'moment'

const EQUIPMENT_PURCHASE_ORDER_STATUS_CHOICES = {
    O: 'Outstanding',
    R: 'Received'
}

export function createOrder(order) {

    let item = {}

    // vendor
    item['vendor'] = order.vendorName

    // date
    item['date'] = moment(order.orderDate).format("M/D/YYYY")

    // totalAmount
    item['totalAmount'] = `$${order.totalCents / 100}`

    // status
    item['status'] = EQUIPMENT_PURCHASE_ORDER_STATUS_CHOICES[order.status]

    // dateReceived
    item['dateReceived'] = order.dateReceived ? moment(order.dateReceived).format("M/D/YYYY") : null

    return item
}